import keys from '@debbie/common/dist/cache/keys.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import { ensureUpdatesLoadedByRef, updatesEntity, useUpdatesByRefId, } from '@debbie/cortex/dist/updates/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { Shortcut } from './/index.js';
import { getActivePauses } from './CasePauseStatus/index.js';
import Activity from './Icons/Activity.js';
import ArrowLeft from './Icons/ArrowLeft.js';
import ArrowRight from './Icons/ArrowRight.js';
import { Button, ButtonGroup } from './index.js';
const CaseQueue = () => {
    const history = useHistory();
    const params = useParams();
    const ids = params.ids?.split(',');
    const id = ids && ids[0];
    const caseIdLoader = useCase(id);
    const singleCaseLoader = useCase(h.hasData(caseIdLoader) ? caseIdLoader.data.caseId : undefined);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const lang = useSelector((s) => s.lang);
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : null;
    const meRole = useRole();
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const caseUpdates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const activePauseUpdates = meRole && getActivePauses(caseUpdates || [], updateTypesMap || {}, meRole);
    const canContinueCase = activePauseUpdates?.every((aPU) => aPU.canContinueCase) &&
        activePauseUpdates.length > 0;
    const [commandButtonPressed, setCommandButtonPressed] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        document.addEventListener('keydown', onDown);
        document.addEventListener('keyup', onUp);
        window.addEventListener('blur', onBlur);
        return () => {
            document.removeEventListener('keydown', onDown);
            document.removeEventListener('keyup', onUp);
            window.removeEventListener('blur', onBlur);
        };
    }, []);
    const onDown = (event) => {
        if (event && [17, 91].includes(event.keyCode)) {
            setCommandButtonPressed(true);
        }
    };
    const onUp = (event) => {
        if ([17, 91].includes(event.keyCode)) {
            setCommandButtonPressed(false);
        }
    };
    const onBlur = () => setCommandButtonPressed(false);
    const forth = () => {
        const replacement = ids?.slice(1, ids.length).join(',');
        const url = history.location.pathname.replace(params.ids, replacement);
        history.push(url);
    };
    const back = () => {
        history.goBack();
    };
    const continueCase = async () => {
        setLoading(true);
        if (commandButtonPressed &&
            canContinueCase &&
            singleCase &&
            activePauseUpdates) {
            await Promise.all(activePauseUpdates.map((u) => updatesLib.patch(u.update.updateId)));
            // Case id
            q.invalidate(keys.write.modify(updatesEntity, ''));
            await ensureUpdatesLoadedByRef(singleCase.caseId);
        }
        forth();
        setLoading(false);
    };
    if (ids && ids.length < 2) {
        return null;
    }
    return (React.createElement(CaseQueueStyled, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": canContinueCase ? lang.cases.pressCommandOrCtrlToContinue : '' },
        lang.cases.casesLeft,
        " ",
        ids && React.createElement("strong", null, ids.length - 1),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(Shortcut, { keys: ['command', 'right'], onPress: (e) => {
                e.preventDefault();
                continueCase();
            }, style: {
                left: '19px',
                top: '6px',
            }, key: `forth-${params.ids}` }),
        React.createElement(Shortcut, { keys: ['command', 'left'], onPress: (e) => {
                e.preventDefault();
                back();
            }, style: {
                left: '-109px',
                top: '6px',
            }, key: `back-${params.ids}` }),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { theme: "secondary", size: "small", onClick: () => {
                    back();
                } },
                React.createElement(ArrowLeft, { style: {
                        verticalAlign: 'middle',
                    } })),
            React.createElement(Button, { size: "small", loading: loading, className: "ui-test-46774c15", onClick: continueCase },
                ids && React.createElement(React.Fragment, null,
                    "#",
                    ids[1],
                    " "),
                commandButtonPressed && canContinueCase && (React.createElement(Activity, { style: {
                        verticalAlign: 'middle',
                    } })),
                React.createElement(ArrowRight, { style: {
                        verticalAlign: 'middle',
                    } })))));
};
export default CaseQueue;
const CaseQueueStyled = styled.div `
  position: fixed;
  border-radius: 2px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);
  bottom: 125px;
  right: 0px;
  background-color: ${THEME.COLOR_SECONDARY};
  padding: ${THEME.GRID_SPACING}px;
  z-index: 1;
`;
//# sourceMappingURL=CaseQueue.js.map